import React, { useEffect } from "react";
import Slider from "react-slick"; // Import react-slick
import "../css/Articles.css"; // Import your custom CSS

const handleItemClick = (_item) => {
    if (_item.url) {
        window.open(_item.url, "_blank");
    }
};

const Articles = ({ resources }) => {
    useEffect(() => {
        // Handle resources change if needed
    }, [resources]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: <img src="/round_right_arrow.svg" alt="Right Arrow" className="right_arrow" />,
        prevArrow: <img src="/round_left_arrow.svg" alt="Left Arrow" className="left_arrow" />,
        responsive: [
            {
                breakpoint: 768, // Mobile breakpoint
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const getBaseUrl = (url) => {
        if (!url) return "Unknown Source"; // Handle null/undefined URLs
        try {
            const parsedUrl = new URL(url);
            return `${parsedUrl.protocol}//${parsedUrl.hostname}`;
        } catch (error) {
            return url; // Return the original URL if parsing fails
        }
    };

    return (
        <section className="articles-section">
            <label className="video-title">Curated Reads</label>
            <span className="tag tag_video"> For You</span>

            {resources === null ? (
                <p>...loading</p>
            ) : resources.length === 0 ? (
                <p>No articles available</p> // ✅ Display only one message when empty
            ) : (
                <Slider {...settings} className="journal-section-container">
                    {resources.map((resource, index) => (
                        <div key={resource.id || index} className="item-article" onClick={() => handleItemClick(resource)}>
                            <div className={`item ${index < resources.length - 1 ? "splitder" : ""}`}>
                                <h3>{resource.title}</h3>
                                <p className="author">{getBaseUrl(resource.url)}</p>
                                <p className="excerpt">
                                    {resource.description.length > 140
                                        ? `${resource.description.substring(0, 140)}...`
                                        : resource.description}
                                    {/* <img src="/more_right_arrow.svg" alt="More" /> */}
                                </p>
                            </div>
                        </div>
                    ))}
                </Slider>
            )}
        </section>
    );
};

export default Articles;
